export default "__VITE_ASSET__BFwkvKC___"